import { useCallback } from "react"

import type { PayFileListFieldsFragment } from "@/graphql/codegen/graphql"
import { useFileDownload } from "@/hooks/useFileDownload"
import { useAuthStore } from "@/stores/authStore"
import { getApiOrigin } from "@/utils/getApiOrigin"

interface UseExportPayFileReturn {
  exportPayFile: (payFile: Pick<PayFileListFieldsFragment, "payFileId" | "referenceNumber">) => Promise<boolean>
  isExporting: boolean
}

export const useExportPayFile = (): UseExportPayFileReturn => {
  const { downloadFile, isLoading } = useFileDownload()

  const exportPayFile = useCallback(
    async ({
      payFileId,
      referenceNumber,
    }: Pick<PayFileListFieldsFragment, "payFileId" | "referenceNumber">): Promise<boolean> => {
      const accessToken = useAuthStore.getState().tokens.accessToken
      const baseUrl = getApiOrigin().replace("/graphql", "")
      const url = `${baseUrl}/file/report/pay_file?payFileId=${payFileId}`

      return downloadFile(url, `pay-file-${referenceNumber}.xlsx`, {
        Authorization: `Bearer ${accessToken}`,
      })
    },
    [downloadFile]
  )

  return { exportPayFile, isExporting: isLoading }
}
